export default "__VITE_ASSET__VMu4Z5Fg__"